// DataContext.js
import { createContext, useContext } from "react";

export const LeadsData = createContext();

export function useLeadsData() {
    return useContext(LeadsData);
}
